import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { AlertComponent } from '../alert/alert.component';
@Component({
  selector: 'app-pix-modal',
  standalone: true,
  imports: [ CommonModule, AlertComponent],
  templateUrl: './pix-modal.component.html',
  styleUrls: ['./pix-modal.component.scss'],
})
export class PixModalComponent{

  @ViewChild(AlertComponent) alertComponent!: AlertComponent;
  constructor() { }

  ngOnInit(): void {
    
  }

  public qrCodeLink: string = '';  // Link da imagem QR code
  public pixCode: string = '';     // Código PIX a ser copiado
  public isVisible: boolean = false;  // Controla a visibilidade do modal

  // Função para abrir o modal com os parâmetros passados
  showModal(qrCodeLink: string, pixCode: string) {
    this.qrCodeLink = qrCodeLink;
    this.pixCode = pixCode;
    this.isVisible = true;
  }

  // Função para fechar o modal
  closeModal() {
    this.isVisible = false;
  }

  // Função para copiar o código PIX para a área de transferência
  copyPixCode() {
    navigator.clipboard.writeText(this.pixCode).then(() => {
        this.alertComponent.showAlert('Codigo Pix Copiado com sucesso!', 'success');
    }).catch(err => {
      console.error('Erro ao copiar o código PIX: ', err);
    });
  }
}
